import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function About() {
    return (
        <main className="bg-gradient-to-b from-slate-900 to-black text-gray-100 py-16 overflow-hidden">
            <section className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 flex flex-col lg:flex-row items-center gap-12">
                {/* 🔹 Text Section */}
                <motion.div
                    className="flex-1 z-10"
                    initial={{ opacity: 0, y: 40 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: "easeOut" }}
                >
                    <h1 className="text-4xl sm:text-5xl font-bold text-white">
                        About SecureID Technologies
                    </h1>

                    <p className="mt-6 text-lg text-gray-300 leading-relaxed">
                        SecureID Technologies builds secure, compliant identity and testing
                        software for agencies and enterprises. Our solutions unify biometric
                        enrollment, testing, and case management into a single reliable
                        platform.
                    </p>

                    <p className="mt-4 text-gray-300 leading-relaxed">
                        We develop technologies that support both online and offline
                        workflows, ensuring business continuity even in the field. From
                        fingerprint Live Scan systems to AI-enabled testing software, our
                        mission is to simplify identity verification through innovation.
                    </p>

                    <h2 className="mt-10 text-2xl font-semibold text-white">
                        What We Stand For
                    </h2>
                    <ul className="mt-3 list-disc pl-6 text-gray-300 space-y-2">
                        <li>
                            <strong>Security-first engineering</strong> with auditability and
                            role-based access.
                        </li>
                        <li>
                            <strong>Offline-first designs</strong> for reliability in field
                            environments.
                        </li>
                        <li>
                            <strong>Standards alignment</strong> (EBTS, FDLE workflows) to
                            meet state and federal compliance.
                        </li>
                    </ul>

                    <h2 className="mt-10 text-2xl font-semibold text-white">
                        Where We Operate
                    </h2>
                    <p className="mt-3 text-gray-300">
                        Based in <strong>Vero Beach, Florida</strong>, we support customers
                        across the United States through remote consulting, training, and
                        secure cloud deployments.
                    </p>

                    <p className="mt-10 text-center lg:text-left text-sm text-gray-400">
                        <Link to="/" className="text-indigo-400 hover:underline">
                            ← Back to Home
                        </Link>
                    </p>
                </motion.div>

                {/* 🔹 Animated Image Section */}
                <motion.div
                    className="flex-1 flex justify-center"
                    initial={{ opacity: 0, x: 200 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1.2, ease: "easeOut" }}
                >
                    <img
                        src="/Images/about-secureid.jpg"
                        alt="SecureID Technologies illustration"
                        className="w-[90%] max-w-md rounded-2xl shadow-2xl"
                    />
                </motion.div>
            </section>
        </main>
    );
}
